import Seo from "@components/common/Seo";
import SmallBanner from "@components/common/SmallBanner";
import Text from "@components/common/Text";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import React, { useEffect, useState } from "react";
// import ProductList from "@base/data/Products";
import Products from "@components/sections/Products";
import ProductsNew from "@components/sections/products2/Products";
import axios from "axios";
import dayjs from "dayjs";
import useSWR from "swr";

// import { navigate } from "gatsby";

const endpoints = {
    products: "/.netlify/functions/products",
};

const Tienda = () => {
    const {
        data: result,
        isLoading,
        isValidating,
    } = useSWR(endpoints.products, axios.get, {
        dedupingInterval: 30 * 1000,
    });
    const [productsState, setProductsState] = useState([]);

    useEffect(() => {
        if (result?.data?.products) {
            let products = result?.data?.products.filter(
                (x) =>
                    x.enabled &&
                    !x.hidden &&
                    x.type === "course" &&
                    x.subtype === "online",
                // x.category?.includes("online")
            );

            products = products.map((p) => {
                const { created_at, updated_at, ...rest } = p;
                return {
                    ...rest,
                    created_at: dayjs(created_at).toDate(),
                    updated_at: dayjs(updated_at).toDate(),
                };
            });

            products = products.sort(
                (a, b) => b.stock - a.stock || b.created_at - a.created_at,
            );

            setProductsState(products);
        }
    }, [result]);

    return (
        <>
            <Layout>
                <Seo
                    title="Nuestra tienda: Cursos online"
                    description="Cursos específicos para cada oposición"
                />
                <SmallBanner
                    title="Cursos online"
                    subtitle="Cursos específicos para cada oposición"
                    filename="bgs/bgCursosOnline"
                />

                <div className="container py-20 lg:px-0">
                    <Title>Cursos disponibles</Title>
                    <Text className="text-justify">
                        Desde casa, a tu ritmo, tutelado por nuestros docentes,
                        todos policías con toda la experiencia para convertirte
                        en el opositor más fuerte.
                    </Text>

                    <div className="mt-10 space-y-10">
                        {process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true" ? (
                            <ProductsNew
                                items={productsState}
                                loading={isLoading || isValidating}
                            />
                        ) : (
                            <Products items={productsState} />
                        )}

                        <div className="mt-10 text-right font-montserrat text-xs italic text-gray-500">
                            * I.V.A. incluido en todos los precios
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Tienda;
